import { EventInput } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react";
import { GenericSuspense, useTranslation, useTranslationLang, useTranslationRoute } from "@harea/component";
import _ from "lodash";
import moment from "moment";
import { useMemo } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDayOffListQuery } from "../hooks/useDayOffListQuery";

export type ProjectDayOffCalendarSectionProps = {
    variables?: any;
};

export const ProjectDayOffCalendarSection = ({ variables }: ProjectDayOffCalendarSectionProps) => {
    const navigate = useNavigate();
    const t = useTranslation();

    const translationLang = useTranslationLang();
    const tr = useTranslationRoute();
    const { data } = useDayOffListQuery(true, variables);
    const events = useMemo(() => data.data?.map<EventInput>(event => ({
        allDay:
            _.isEmpty(event.hourBegin) ||
            _.isEmpty(event.hourEnd),
        id: event?.id as any,
        title: `${event.employee?.fullName ?? ""} - ${t(`Generic.de.${event.type?.designation}`)}`,
        start: event.dateBegin,
        end: event.dateEnd,
        extendedProps: event,
    })) ?? [], [data.data, t]);

    return (
        <FullCalendar
            plugins={[dayGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            dayHeaderContent={dayHeaderContent}
            locale={translationLang.lang}
            stickyHeaderDates={false}
            stickyFooterScrollbar={true}
            headerToolbar={{left: "title", end: "prev,next"}}
            nowIndicator
            validRange={(now) => ({ start: now })}
            events={events}
            eventClick={(arg) => {
                navigate(tr(`admin/timeoffs/demands/${arg.event.id}`));
            }}
            dateClick={(arg) => {
                navigate(
                    tr(
                        `admin/project/dayoff/calendar/create?dateBegin=${moment(
                            arg.date
                        ).format("YYYY-MM-DD")}`
                    )
                );
            }}
        />
    );
};

const ProjectDayOffViewsCalendarContainer = () => {
    return (
        <>
            <ProjectDayOffCalendarSection />
            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </>
    );
};

export default ProjectDayOffViewsCalendarContainer;

const dayHeaderContent = (arg) => (
    <span className="text-xs text-gray">
        <b>{moment(arg.date).format("dddd")}</b>
    </span>
);
